import type { HTMLSerializeOptions } from '@lumapps/wrex/serialization/html/toHTML/types';

import { CODE_BLOCK } from '../../constants';

export const CODE_BLOCK_ELEMENTS: HTMLSerializeOptions['elements'] = {
    [CODE_BLOCK]: (_, children) => `<pre><code>${children}</code></pre>`,
};
